import images from "@assets/images";
import DrawerList from "@src/utils/mockdata/drawer-list";
import _ from "lodash";
import React from "react";
import { Image, Text, TouchableOpacity,View } from "react-native";
import { DrawerContext } from "../../drawer-provider";
import useStyles from "./styles.css";
import { selectStorage } from "@src/ducks/slices/user.slice";
import numeral from "numeral";
import { useAppSelector } from "@src/ducks/ducksHook";
import { selectIsFreePlan } from "@src/ducks/slices/user.slice";

const TitleSection = () => {
  const styles = useStyles();
  const { activeTab, activeSecondScreen, onSetActiveSecondScreen } = React.useContext(DrawerContext);
  const storage = useAppSelector(selectStorage);
  const isFreePlan = useAppSelector(selectIsFreePlan);

  const Title = React.useMemo(() => {
    return _.find(DrawerList, { "name": activeTab })?.page ?? activeTab;
  },[activeTab]);

  const backLabel = React.useMemo(() => {
    switch(activeSecondScreen){
    case "inbox-details":
      return "Back to Inbox";
    }
  },[activeSecondScreen]);

  const subTitleLabel = React.useMemo(() => {
    if (isFreePlan) {
      return `${numeral(storage.used).format("0.00")} MB of ${numeral(storage.totalStorage).format("0")} MB used`
    }
    return `${numeral(storage.used).format("0.00")} GB of ${numeral(storage.totalStorage).format("0")} GB used`
  }, [isFreePlan, storage])

  return _.isEmpty(backLabel) ? 
     (
    <>
      <Text style={styles.t_title}>{Title} 
        {(activeTab === "Documents" || ((activeTab === "Create Document" || activeTab === "Dashboard") && isFreePlan)) &&
          <>
            <br/>
            <View style={styles.subtitle_container}>
              <Text style={styles.t_storage}>
                {subTitleLabel}
              </Text>
            </View>
          </>
        }
      </Text>
    </>
   )
  : (
    <TouchableOpacity activeOpacity={0.9} style={styles.button_back} 
      onPress={() => onSetActiveSecondScreen("")}>
      <Image style={{width: 21, height: 11}} source={images.ic_back} resizeMode="contain"/>
      <Text style={styles.t_title_back}>{backLabel}</Text>
    </TouchableOpacity>
  );
};

export default TitleSection;
